import React from "react";
import AttachmentDisplay from "./AttachmentDisplay";
import { Message } from "../../../types/support.types";

interface MessageBubbleProps {
  message: Message;
  isOwnMessage: boolean;
  senderName: string;
  senderInitial: string;
  formatTime: (dateString: string) => string;
  isSystemMessage?: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({
  message,
  isOwnMessage,
  senderName,
  senderInitial,
  formatTime,
  isSystemMessage = false,
}) => {
  // System message styling
  if (isSystemMessage) {
    return (
      <div className="my-8">
        <div className="flex items-center justify-center">
          <div className="flex-1 border-t border-gray-300"></div>
          <div className="mx-4 bg-amber-50 text-amber-800 text-sm px-6 py-3 rounded-lg border-2 border-amber-200 shadow-sm font-medium">
            {message.message}
          </div>
          <div className="flex-1 border-t border-gray-300"></div>
        </div>
      </div>
    );
  }

  if (isOwnMessage) {
    return (
      <div className="flex justify-end">
        <div className="flex flex-col items-end max-w-lg">
          <div className="flex items-center space-x-2 mb-2">
            <span className="text-xs text-gray-500">
              {formatTime(message.created_at)}
            </span>
            <span className="text-sm font-medium text-gray-900">
              {senderName}
            </span>
          </div>
          <div className="bg-white rounded-2xl rounded-tr-md px-4 py-3 shadow-sm border border-gray-100">
            <p className="text-gray-900 text-sm leading-relaxed">
              {message.message}
            </p>
            <AttachmentDisplay message={message} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start">
      <div className="flex items-start space-x-3 max-w-lg">
        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-white text-sm font-semibold">
            {senderInitial}
          </span>
        </div>
        <div className="flex flex-col">
          <div className="flex items-center space-x-2 mb-2">
            <span className="text-sm font-medium text-gray-900">
              {senderName}
            </span>
            <span className="text-xs text-gray-500">
              {formatTime(message.created_at)}
            </span>
          </div>
          <div className="bg-blue-500 text-white rounded-2xl rounded-tl-md px-4 py-3 shadow-sm">
            <p className="text-sm leading-relaxed">{message.message}</p>
            <AttachmentDisplay message={message} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
